/** biome-ignore-all lint/style/useNamingConvention: camel case */
import {
  ADD_FAILED_PHOTO,
  ADD_PENDING_PHOTO,
  CLEAR_FEATURED_PHOTO,
  CLEAR_PENDING_PHOTO,
  CLEAR_PENDING_PHOTOS,
  CONVERT_TO_FAILED,
  FEATURE_PHOTO,
  MARK_UPLOAD_SUCCESS,
  MARK_UPLOAD_UPLOADING,
  NAME_HOST_GALLERY,
  PHOTO_STATUS,
} from './constants';

const initialState = {
  photos: [],
  hostPhotos: [],
  hostGalleryName: '',
  featuredPhoto: null,
};

// Create a photo object and update the proper collection.
const updatePhotoCollection = (state, action, isError) => {
  const {id, file, collection, reason} = action.payload;
  const newPhoto = {
    id,
    file,
    status: isError ? PHOTO_STATUS.ERROR : PHOTO_STATUS.PENDING,
    ...(isError && {reason}),
  };

  const prevCollection = state[collection] || [];
  const updatedCollection = [...prevCollection, newPhoto];

  return {
    ...state,
    [collection]: updatedCollection,
  };
};

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NAME_HOST_GALLERY: {
      return {
        ...state,
        hostGalleryName: action.payload,
      };
    }
    case FEATURE_PHOTO: {
      // Remove isStaged from all and position from old featured photo
      const modifiedPhotos = state.hostPhotos.length
        ? state.hostPhotos.map((photo) => {
            if (photo.id === action.payload.id) {
              return action.payload;
            }
            // biome-ignore lint/correctness/noUnusedVariables: isStaged not used
            const {isStaged, ...rest} = photo;
            return rest;
          })
        : [action.payload];
      const hostPhotos = action.payload.isStaged ? modifiedPhotos : state.hostPhotos;

      return {
        ...state,
        featuredPhoto: action.payload,
        hostPhotos,
      };
    }
    case CLEAR_FEATURED_PHOTO: {
      return {
        ...state,
        hostPhotos: state.hostPhotos.map(({position, ...rest}) => rest),
        featuredPhoto: null,
      };
    }
    case ADD_PENDING_PHOTO:
      return updatePhotoCollection(state, action, false);
    case ADD_FAILED_PHOTO:
      return updatePhotoCollection(state, action, true);
    case CLEAR_PENDING_PHOTOS: {
      return {
        ...state,
        photos: [],
        hostPhotos: [],
      };
    }
    case CLEAR_PENDING_PHOTO: {
      const {id, collection} = action.payload;
      const newPhotos = state[collection].filter((item) => item.id !== id);

      return {
        ...state,
        [collection]: [...newPhotos],
      };
    }
    case CONVERT_TO_FAILED: {
      const {id, reason, collection = 'photos'} = action.payload;
      const updated = state[collection].map((p) =>
        p.id === id ? {...p, reason, status: PHOTO_STATUS.ERROR} : p
      );
      return {
        ...state,
        [collection]: updated,
      };
    }
    case MARK_UPLOAD_SUCCESS: {
      const {id, photoId, collection = 'photos'} = action.payload;
      const updated = state[collection].map((p) =>
        p.id === id ? {...p, photoId, status: PHOTO_STATUS.SUCCESS} : p
      );
      return {
        ...state,
        [collection]: updated,
      };
    }
    case MARK_UPLOAD_UPLOADING: {
      const {id, collection = 'photos'} = action.payload;
      const updated = state[collection].map((p) =>
        p.id === id ? {...p, status: PHOTO_STATUS.UPLOADING} : p
      );
      return {
        ...state,
        [collection]: updated,
      };
    }

    default:
      return state;
  }
}
